import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"mt-10 d-flex flex-column align-center justify-center transparent",attrs:{"flat":""}},[_c(VImg,{attrs:{"src":_vm.imageName,"max-height":"300","contain":""}}),_c('span',{staticClass:"display-1 font-weight-light text--disabled"},[_vm._v(_vm._s(_vm.title))]),(!_vm.hasDescriptionSlot)?_c('span',{staticClass:"body-1 font-weight-light text--secondary mt-1"},[_vm._v(_vm._s(_vm.text))]):_vm._t("description")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }